import i18n from 'modules/core/lib/i18n'

import { AlertMessage, Description, List, ListEl, Note, Title } from './elements'

export const Join = () => {
  return (
    <>
      <Title>{i18n.t('app_store_v2.integrations.join.description_view.title_1')}</Title>
      <Description>
        {i18n.t('app_store_v2.integrations.join.description_view.description_1.paragraph_1')}
      </Description>
      <Note>
        {i18n.t('app_store_v2.integrations.join.description_view.description_1.paragraph_2')}
      </Note>
      <Description>
        {i18n.t('app_store_v2.integrations.join.description_view.description_1.paragraph_3')}
      </Description>
      <Title>{i18n.t('app_store_v2.integrations.join.description_view.title_2')}</Title>
      <Description>
        {i18n.t('app_store_v2.integrations.join.description_view.description_2')}
      </Description>
      <List>
        <ListEl>
          {i18n.t('app_store_v2.integrations.join.description_view.list_1.1.text')}{' '}
          <a
            href={i18n.t('app_store_v2.integrations.join.description_view.list_1.1.url')}
            target="_blank"
            rel="noreferrer"
          >
            {i18n.t('app_store_v2.integrations.join.description_view.list_1.1.link_text')}
          </a>
        </ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.join.description_view.list_1.2')}</ListEl>
        <ListEl>{i18n.t('app_store_v2.integrations.join.description_view.list_1.3')}</ListEl>
      </List>
      <Description>
        {i18n.t('app_store_v2.integrations.join.description_view.description_3')}
      </Description>
      <AlertMessage>
        {i18n.t('app_store_v2.integrations.join.description_view.waning_message_2')}
      </AlertMessage>
    </>
  )
}
